'use client';

import { useState } from 'react';
import { Search } from './search';
import { FeatureFlag } from './feature-flag';
import type { Flag } from '../types';
import css from './experiments.module.scss';

interface Props {
    flags: Flag[];
}
export function Experiments({ flags }: Props) {
    const [search, setSearch] = useState('');

    return (
        <div className={css.section}>
            <Search search={search} onSearch={setSearch} />

            <div className={css.list}>
                {flags
                    .filter(f => f.key.includes(search))
                    .map(flag => (
                        <>
                            <FeatureFlag key={flag.key} flag={flag} />
                            <div className={css.divider} />
                        </>
                    ))}
            </div>
        </div>
    );
}
